import axios from "../../API/axios";
import React, { useEffect, useState } from "react";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";

const PageNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const language = localStorage.getItem("Lang");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [errorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  useEffect(() => {
    const pageNotification = async () => {
      const sessionId = localStorage.getItem("sessionId");
      const token = localStorage.getItem("token");

      if (!sessionId || !token) {
        setErrorToastMessage("Authentication error. Please log in again.");
        setShowErrorToast(true);
        setLoading(false);
        return;
      }
      setLoading(true);

      const data = {
        deviceType: "Web",
        sessionId: sessionId,
        langKey: language === "en" ? "" : language,
      };

      try {
        const response = await axios.post(`/Account/NotificationConfig`, data);
        // console.log("API Response:", response.data);
        setNotifications(response.data.responseData);
        setToastMessage("Notification settings loaded successfully.");
        setShowToast(true);
      } catch (error) {
        if (error.response) {
          if (error.response.status === 404) {
            setWarningToastMessage(
              error.response.data.message || "No notifications found."
            );
            setShowWarningToast(true);
          } else {
            setErrorToastMessage(
              error.response.data.message || "Something went wrong."
            );
            setShowErrorToast(true);
          }
        } else {
          setErrorToastMessage("Network error. Please try again.");
          setShowErrorToast(true);
        }
      } finally {
        setLoading(false);
      }
    };

    pageNotification();
  }, []);

  const updateNotificationStatus = async (notif, key, updatedValue) => {
    const sessionId = localStorage.getItem("sessionId");
    const token = localStorage.getItem("token");

    if (!sessionId || !token) {
      setErrorToastMessage("Authentication error. Please log in again.");
      setShowErrorToast(true);
      setLoading(false);
      return;
    }

    const updateData = {
      deviceType: "Web",
      sessionId,
      ncid: notif.ncid,
      langKey: language === "en" ? "" : language,
      [key]: updatedValue,
    };

    try {
      const response = await axios.post(
        `/Account/UpdateNotificationConfig?ConfigType=${key}`,
        updateData
      );

      setNotifications((prev) =>
        prev.map((item) =>
          item.ncid === notif.ncid ? { ...item, [key]: updatedValue } : item
        )
      );

      setToastMessage(
        response.data.message || "Notification updated successfully."
      );
      setShowToast(true);
    } catch (error) {
      // console.log(object)
      setErrorToastMessage("Failed to update notification.");
      setShowErrorToast(true);
    }
  };

  const handleToggle = (notif, key) => {
    if (notif[key] === null) return;
    updateNotificationStatus(notif, key, !notif[key]);
  };

  return (
    <>
      <div className="setting-header">
        <h4>Notification Setting</h4>
      </div>
      <div>
        <div className="notificationTable">
          <table width="100%">
            <thead>
              <tr>
                <th>Notify me when</th>
                <th>Web</th>
                <th>App</th>
                <th>Email</th>
                <th>SMS</th>
              </tr>
            </thead>
            <tbody>
              {notifications.length > 0 ? (
                notifications.map((notif, index) => (
                  <tr key={index}>
                    <td>{notif.title}</td>
                    <td>
                      <label className="switch">
                        {notif.web === null ? (
                          ""
                        ) : (
                          <>
                            <input
                              type="checkbox"
                              defaultChecked={notif.web}
                              disabled={notif.web === null}
                              onChange={() => handleToggle(notif, "web")}
                            />
                            <span className="slider round"></span>
                          </>
                        )}
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        {notif.app === null ? (
                          ""
                        ) : (
                          <>
                            <input
                              type="checkbox"
                              defaultChecked={notif.app}
                              onChange={() => handleToggle(notif, "app")}
                            />
                            <span className="slider round"></span>
                          </>
                        )}
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        {notif.email === null ? (
                          ""
                        ) : (
                          <>
                            <input
                              type="checkbox"
                              defaultChecked={notif.email}
                              disabled={notif.email === null}
                              onChange={() => handleToggle(notif, "email")}
                            />
                            <span className="slider round"></span>
                          </>
                        )}
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        {notif.sms === null ? (
                          ""
                        ) : (
                          <>
                            <input
                              type="checkbox"
                              defaultChecked={notif.sms}
                              disabled={notif.sms === null}
                              onChange={() => handleToggle(notif, "sms")}
                            />
                            <span className="slider round"></span>
                          </>
                        )}
                      </label>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No notifications found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Toast Messages */}
      {showToast && (
        <SuccessToast
          message={toastMessage}
          onClose={() => setShowToast(false)}
        />
      )}
      {showWarningToast && (
        <WarningToast
          message={warningToastMessage}
          onClose={() => setShowWarningToast(false)}
        />
      )}
      {showErrorToast && (
        <ErrorToast
          message={errorToastMessage}
          onClose={() => setShowErrorToast(false)}
        />
      )}
    </>
  );
};

export default PageNotifications;
